<template>
  <div id="search">
    <div id="search-bar" v-bind:class="{ 'border-bottom': search_suggestions.length === 0 }">
      <input placeholder="Search WSHS"
             v-model="query"
             @input="input_change" />

      <i class="material-icons search">search</i>

      <div></div>

      <img id="make-route"
           width="20px"
           height="20px"
           @click="$emit('open_route_card')"
           src="../assets/directions.svg"
           alt="Directions"
           />
    </div>

    <div id="search-items" class="border-bottom" v-if="search_suggestions.length>0">
      <div class="search-item"
           @click="select_room(room)"
           v-for="room in search_suggestions"
           :key="room.name">
        <i class="material-icons destination">location_on</i>
        {{ room.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    search_suggestions: Array
  },
  data() {
    return {
      query: ''
    }
  },
  methods: {
    input_change(e) { this.$emit('update_suggestions', e) },
    select_room(room) {
      this.query = room.name
      this.$emit('room_selected', {
        name: room.name,
        floor: room.floor,
        src: room.name==='Main Office'
          ? require('../assets/office.svg')
          : room.name==='Cafeteria'
          ? require('../assets/cafeteria.svg')
          : room.name==='Clinic'
          ? require('../assets/health.svg')
          : room.name==='Library'
          ? require('../assets/library.svg')
          : room.name==='Auditorium'
          ? require('../assets/auditorium.svg')
          : room.name==='Main Gym' || room.name==='Aux Gym'
          ? require('../assets/gym.svg')
          : require('../assets/classroom.svg')
      })
    }
  }
}
</script>

<style scoped>
#search {
  border-radius: 10px;
  box-shadow: 0 0 20px 0 #0000004d;
}

#search-bar {
  display: flex;
  width: 370px;
  padding: 13px 15px;
  align-items: center;
  flex-direction: row;
  background-color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-family: Rubik, sans-serif;
}

.search-bar-label {
  position: absolute;
  color: white;
  padding: 3px 8px;
  border-radius: 5px;
  background-color: #202124;
}

#menu-label { left: 0; }
#search-label { right: 0; }

.border-bottom {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

#search-items {
  width: 100%;
  max-height: 300px;
  overflow: auto;
  cursor: pointer;
  background-color: white;
}

.search-item {
  display: flex;
  height: 40px;
  align-items: center;
  flex-direction: row;
}
.search-item:hover { background-color: #f2f4f7; }

.search {
  font-size: 20px;
  color: #859ba6;
}

.destination {
  color: #859ba6;
  margin: 0 20px;
}

#search-bar svg { margin-right: 10px; }
#make-route { cursor: pointer; }
#search-bar div {
  width: 2px;
  height: 20px;
  margin: 0 10px;
  background-color: #dadce0;
}

input {
  border: 0;
  outline: 0;
  flex-grow: 1;
  font-size: 15px;
}

@media (max-width: 768px) {
  #search { border-radius: 0; }
  #search-bar { width: calc(100vw - 30px); }
  .border-bottom {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>